import { useEffect } from 'react';

import { modalTypes } from '@/enums';
import { useIsVipEnabled } from '@/hooks/useIsVipEnabled';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getBidderId } from '@/redux/modules/account/user/user.selectors';
import { openVipConfirmationModal } from '@/redux/modules/modal';
import { getOpenModal } from '@/redux/modules/modal.selectors';

import { VipConfirmationModal } from './VipConfirmationModal';

const hasSeenVipConfirmation = (vipConfirmationStorageKey: string) =>
    typeof window !== 'undefined' && localStorage.getItem(vipConfirmationStorageKey) === 'true';

const VipConfirmationModalTrigger = () => {
    const dispatch = useAppDispatch();
    const bidderId = useAppSelector(getBidderId);
    const isVipEnabled = useIsVipEnabled();
    const openModal = useAppSelector(getOpenModal);
    const isVipOpen = openModal === modalTypes.VIP_CONFIRMATION;
    const isModalOpen = openModal !== modalTypes.NONE;
    const vipConfirmationStorageKey = `vipConfirmation-${bidderId}`;
    const shouldOpen = isVipEnabled && !isModalOpen && !hasSeenVipConfirmation(vipConfirmationStorageKey);

    useEffect(() => {
        if (shouldOpen) {
            localStorage.setItem(vipConfirmationStorageKey, 'true');
            dispatch(openVipConfirmationModal());
        }
    }, [dispatch, shouldOpen, vipConfirmationStorageKey]);

    if (!isVipOpen) {
        return null;
    }

    return <VipConfirmationModal />;
};

export default VipConfirmationModalTrigger;
